import Vue from 'vue'
import seajs from 'seajs-amd'
import 'seajs-amd/lib/plugins/css'
import store from '@store'
import router from '@studio/router'
import {
    formatEmulator,
    getFormattedUri,
    formatModules,
    resolveModule,
    namespaceData,
} from '@utils/asyncFormatter'
import fetchData from './fetch-data'

export default {
    mixins: [fetchData],
    methods: {
        initSeajs(data, components) {
            const [{ emulatorVersion, emulatorBuildTime }] = data

            // 间隔五分钟刷新缓存时间
            function getCacheTime() {
                const buildComponentTime = new Date()
                let minute = buildComponentTime.getMinutes()
                const remainder = minute % 5
                if (remainder !== 0) {
                    minute -= remainder
                }
                buildComponentTime.setMinutes(minute)
                buildComponentTime.setSeconds(0)
                buildComponentTime.setMilliseconds(0)
                return buildComponentTime.getTime()
            }

            const cacheTime = getCacheTime()

            const emulatorPath = `/studio/system/emulator/${emulatorVersion}`
            seajs.on('resolve', resolveModule)

            seajs.on('fetch', dataUri => {
                dataUri.requestUri = getFormattedUri(dataUri.uri, cacheTime, components)
            })

            return seajs.config({
                map: [
                    id => formatEmulator(id, emulatorBuildTime),
                    id => formatModules(id, cacheTime, namespaceData),
                ],
                paths: {
                    emulator: `${emulatorPath}`,
                    'paas-sdk': `${emulatorPath}`,
                },
            })
        },
        loadEmulator() {
            return new Promise(resolve => {
                seajs.use(
                    ['emulator/emulator.js', 'emulator/emulator.css'],
                    module => {
                        Vue.use(module, { rootStore: store, router })
                        resolve()
                    }
                )
            })
        },
        loadHooks(hooks, _businessEnvDetail = {}) {
            return new Promise(resolve => {
                if (hooks && hooks.length) {
                    seajs.use(
                        [
                            ...hooks.reduce(
                                (array, hook) => array.concat(hook.paths),
                                []
                            ),
                        ],
                        (...modules) => {
                            modules.forEach(module => {
                                if (module) {
                                    Vue.use(module, {
                                        store,
                                        router,
                                        addHook: () => {},
                                        callHook: () => {},
                                        ..._businessEnvDetail,
                                    })
                                }
                            })
                            resolve()
                        }
                    )
                } else {
                    resolve()
                }
            })
        },
    },
}
